module.exports = "/_next/static/images/7f926e1fd2062f6690b075b1b4e6172c-slide3mobile.jpg";